import type { Reducer } from 'redux';

import type { AuthActions } from './actions';
import * as types from './types';
import { Nullable } from 'ts';
import { queryClient } from 'api/query';

export const INITIAL_STATE = {
  isAuthReady: false,
  isLoading: false,
  error: null as Nullable<string> | Record<string, unknown[]>,
  resetPassword: false,
  isFirstLogin: false,
  isUploadDocsVerificationShown: false,
  isReUploadDocs: false,
};

const reducer: Reducer<typeof INITIAL_STATE, AuthActions> = (state = INITIAL_STATE, action): typeof INITIAL_STATE => {
  switch (action.type) {
    case types.LOGOUT_SUCCESS: {
      queryClient.getQueryCache().clear();
      queryClient.clear();
      return INITIAL_STATE;
    }

    case types.REGISTER_USER_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }
    case types.REGISTER_USER_SUCCESS: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case types.REGISTER_USER_FAILED: {
      const { error } = action.payload;
      return {
        ...state,
        isLoading: false,
        error,
      };
    }
    case types.LOGIN_REQUEST: {
      return {
        ...state,
        isLoading: true,
        isAuthReady: false,
        error: null,
      };
    }
    case types.LOGIN_SUCCESS: {
      const { isFirstLogin } = action.payload;
      return {
        ...state,
        isLoading: false,
        isAuthReady: true,
        isFirstLogin: isFirstLogin,
      };
    }
    case types.LOGIN_FAILED: {
      const { error } = action.payload;
      return {
        ...state,
        isLoading: false,
        isAuthReady: true,
        error,
      };
    }
    case types.AUTO_LOGIN_REQUEST: {
      return {
        ...state,
        isLoading: true,
        isAuthReady: false,
        error: null,
      };
    }
    case types.LOGIN_BY_VERIFICATION_CODE_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }
    case types.LOGIN_BY_VERIFICATION_CODE_SUCCESS: {
      const { isFirstLogin } = action.payload;
      return {
        ...state,
        isLoading: false,
        isFirstLogin: isFirstLogin,
      };
    }
    case types.LOGIN_BY_VERIFICATION_CODE_FAILED: {
      const { error } = action.payload;
      return {
        ...state,
        isLoading: false,
        error,
      };
    }
    case types.LOGOUT_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }

    case types.LOGOUT_FAILED: {
      const { error } = action.payload;
      return {
        ...state,
        isLoading: false,
        error,
      };
    }
    case types.RESET_PASSWORD_REQUEST: {
      return {
        ...state,
        isLoading: true,
        isAuthReady: false,
        error: null,
      };
    }
    case types.RESET_PASSWORD_SUCCESS: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case types.RESET_PASSWORD_FAILED: {
      const { error } = action.payload;
      return {
        ...state,
        isLoading: false,
        error,
      };
    }
    case types.CONFIRM_RESET_PASSWORD_REQUEST: {
      return {
        ...state,
        resetPassword: false,
        isLoading: true,
        isAuthReady: false,
        error: null,
      };
    }
    case types.CONFIRM_RESET_PASSWORD_SUCCESS: {
      return {
        ...state,
        resetPassword: true,
        isLoading: false,
      };
    }
    case types.CONFIRM_RESET_PASSWORD_FAILED: {
      const { error } = action.payload;
      return {
        ...state,
        isLoading: false,
        error,
      };
    }
    case types.CONFIRM_REGISTRATION_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }
    case types.CONFIRM_REGISTRATION_SUCCESS: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case types.CONFIRM_REGISTRATION_FAILED: {
      const { error } = action.payload;
      return {
        ...state,
        isLoading: false,
        error,
      };
    }
    case types.UPLOAD_VERIFICATION_DOCUMENTS_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }
    case types.UPLOAD_VERIFICATION_DOCUMENTS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isUploadDocsVerificationShown: false,
      };
    }
    case types.UPLOAD_VERIFICATION_DOCUMENTS_FAILED: {
      const { error } = action.payload;
      return {
        ...state,
        isLoading: false,
        isUploadDocsVerificationShown: true,
        error,
      };
    }
    case types.SHOW_UPLOAD_VERIFICATION_DOCUMENTS_MODAL: {
      const { reUpload } = action.payload;
      return {
        ...state,
        isUploadDocsVerificationShown: true,
        isReUploadDocs: reUpload,
      };
    }
    case types.HIDE_UPLOAD_VERIFICATION_DOCUMENTS_MODAL: {
      return {
        ...state,
        isUploadDocsVerificationShown: false,
      };
    }
    case types.CLEAR_ERROR: {
      return {
        ...state,
        error: null,
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
